<template>
    <div id="ip-overview">
        <section class="left-side">
            <h2><template v-if="!!i18nText.filterItem">{{$t(i18nText.filterItem)}}</template><template v-else>筛选项</template></h2>
            <div v-loading="filterLoading"> 
              <div v-if="filterListTemp.length > 0">
                <template  v-for="(item,index) in filterListTemp">
                  <ip-patent-result-filter :title="item.title" :key="index"
                                          :is-i18n="Object.keys(i18nText).length > 0"
                                          :no-data="i18nText.noDataQueried"
                                          :value="item.value"
                                          :active="item.active"
                                          :list="item.list"
                                          @change-filter="handleChangeFilter(item,arguments)">
                  </ip-patent-result-filter>
                </template>
              </div>
              <div v-else>
                <template v-if="!!i18nText.noDataQueried">
                    <el-alert :title="$t(i18nText.noDataQueried)" type="info" :closable="false"></el-alert>
                </template>
                <template v-else>
                    <el-alert title="没有查询到数据" type="info" :closable="false"></el-alert>
                </template>
              </div>  
            </div>
        </section>
        <section class="right-side">   
            
            <section class="tool-container">
                <div class="filter-condition"><h2><template v-if="!!i18nText.filterCondition">{{$t(i18nText.filterCondition)}}</template><template v-else>筛选条件</template>：</h2>
                    <el-button type="text" @click="clearfilterConditionTemp"><template v-if="!!i18nText.clearfilter">{{$t(i18nText.clearfilter)}}</template><template v-else>清空筛选</template></el-button>
                    <el-button type="primary" class="pull-right" style="margin-top:6px" size="mini" @click="filter">
                      <template v-if="!!i18nText.filter">
                          {{$t(i18nText.filter)}}
                      </template>
                      <template v-else>
                          筛选
                      </template>
                    </el-button>
                </div>
                <div v-for="(item,index) in filterConditionTemp" :key="index" class="mb8">
                    <template v-if="Object.keys(i18nText).length > 0 ">
                        <span>{{$t(item.title)}}</span>
                    </template>
                    <template v-else>
                        <span>{{item.title}}</span>
                    </template>
                    <el-tag v-for="(tag,index) in item.list" closable :key="index" @close="closefilterConditionTemp(item.title,item,index)">{{tag}}</el-tag>
                </div>
            </section>
            <section class="right-container" v-loading="loading">
                <section class="tool-container">
                    <section>
                        <span class="tool-item">
                            <el-button-group>
                                <el-button size="small" @click="checkThisPage">
                                  <template v-if="!!i18nText.checkThisPage">
                                      {{$t(i18nText.checkThisPage)}}
                                  </template>
                                  <template v-else>
                                      全选本页
                                  </template>  
                                </el-button>
                                <el-button size="small" @click="unCheckThisPage">
                                  <template v-if="!!i18nText.cancelThisPage">
                                      {{$t(i18nText.cancelThisPage)}}
                                  </template>
                                  <template v-else>全页取消</template>
                                </el-button>
                                <el-button size="small" @click="unCheckAll">
                                  <template v-if="!!i18nText.unCheckAll">{{$t(i18nText.unCheckAll)}}</template>
                                  <template v-else>全部取消</template>
                                </el-button>
                            </el-button-group>
                        </span>
                        <span class="tool-item">
                            <el-button type="text" @click="changeMode('list')">
                                <i class="iconfont ipiconimgtext"></i> 
                                <template v-if="!!i18nText.imgText">
                                    {{$t(i18nText.imgText)}}
                                </template>
                                <template v-else>
                                    图文式
                                </template>  
                            </el-button>
                        </span>
                        <span class="tool-item">
                            <el-button type="text" @click="changeMode('table')">
                                <i class="iconfont ipicontable"></i>
                                <template v-if="!!i18nText.table">
                                    {{$t(i18nText.table)}}
                                </template>
                                <template v-else>
                                    列表式
                                </template>  
                            </el-button>
                        </span>
                        <span class="tool-item">
                            <el-button type="text" @click="changeMode('pic')">
                                <i class="iconfont ipiconimg"></i>
                                 <template v-if="!!i18nText.pic">
                                    {{$t(i18nText.pic)}}
                                </template>
                                <template v-else>
                                    首图式
                                </template>  
                            </el-button>
                        </span>
                        <slot name="page-tool"></slot>
                    </section>
                </section>
                <section v-if="tradeResultListTemp.length > 0">
                  <el-row class="page-sort">
                      <div class="pull-left">
                          <el-select v-model="sortTemp" size="mini" @change="handleSortChange">
                              <template v-if="Object.keys(i18nText).length > 0">
                                      <el-option v-for="(item,index) in sortOption"
                                        :label="$t(item.label)"
                                        :value="item.value"
                                        :key="index"></el-option>
                              </template>
                              <template v-else>
                                <el-option v-for="(item,index) in sortOption"
                                        :label="item.label"
                                        :value="item.value"
                                        :key="index"></el-option>
                              </template>  
                          </el-select>
                      </div>
                      <div class="pull-right">
                          <el-pagination
                                  @size-change="handleSizeChange"
                                  @current-change="handleCurrentChange"
                                  :current-page="currentPage"
                                  :page-sizes="pageSizes"
                                  :page-size="pageSize"
                                  layout="total, sizes, prev, pager, next, jumper"
                                  :total="total">
                          </el-pagination>
                      </div>
                  </el-row>
                  <template v-if="displayMode==='list'">
                      <template v-for="(item,index) in tradeResultListTemp">
                          <div class="trade-list-item" :key="index">
                              <span class="trade-checkbox"><el-checkbox v-model="item.checked" @change="changeCurrentCheckBox(item)"></el-checkbox></span>
                              <ip-patent-info-panel :index="item.index" :title="item.title" :field-list="item.fieldList" :i18n-text="i18nText" :title-tag="item.titleTag" :img-tag="item.imgTag"
                                                    :icon-tag="item.iconTag"
                                                    :is-show-img="item.isShowImg" :img-positon="item.imgPositon" :is-single-img="item.isSingleImg" :url-list="item.url"
                                                    @drilling="handleDrilling(item, $event)">
                                  <template slot="title">
                                      <slot name="title" :data="item"></slot>  
                                  </template>
                                  <template slot="tool">
                                      <slot name="tool-text" :data="item"></slot>  
                                  </template>
                                  <template slot="single-field" slot-scope="data">
                                    <slot name="single-field" :data="data"></slot>
                                  </template>  
                              </ip-patent-info-panel>
                          </div>
                      </template>
                  </template>
                  <template v-if="displayMode==='table'">
                      <section class="trade-table">
                          <el-row :gutter="8" class="table-title">
                              <el-col :span="1">&nbsp;</el-col>
                              <el-col v-for="(item,index) in tableField" :key="index" :span="item.span">
                                <template v-if="Object.keys(i18nText).length > 0">
                                    {{$t(item.text)}}
                                </template>
                                <template v-else>{{item.text}}</template>
                              </el-col>
                              <el-col v-if="Object.keys(i18nText).length > 0" :span="2">{{$t(i18nText.operate)}}</el-col>
                              <template v-else>
                                  <el-col :span="2">操作</el-col>
                              </template>
                          </el-row>
                          <template v-for="(item,index) in tradeResultListTemp">
                              <el-row class="trade-table-item" :key="index">
                                  <el-col :span="1"><el-checkbox v-model="item.checked" @change="changeCurrentCheckBox(item)"></el-checkbox></el-col>
                                  <template v-for="(tf,index) in tableField">
                                    <el-col :span="tf.span" class="table-td" :key="index">  
                                          <template v-if="!!tf.isTitle">
                                              <span  class="long-word" style="text-align:left">
                                                  <slot name="title" :data="item"></slot>
                                              </span>
                                          </template> 
                                          <template v-else>
                                              <template v-if="!tf.isImg && !tf.isIconTag">
                                                <span  class="long-word" :title="item[tf.value]">
                                                   <template v-if="item[tf.value]">{{item[tf.value]}}</template>
                                                   <template v-else-if="Object.keys(i18nText).length > 0">
                                                    {{$t(i18nText.noData)}}</template>
                                                    <template v-else>暂无数据</template>
                                                </span>
                                              </template>
                                              <div v-if="tf.isImg">
                                                <div class="table-img">
                                                  <template v-if="item[tf.value]">
                                                      <img :src="item[tf.value]">
                                                  </template>  
                                                  <div v-else>
                                                      <i class="el-icon-picture" style="color:#cccccc;"></i>
                                                  </div>
                                                </div>
                                                <div v-if="item.imgTag && !!item.imgTag.text" class="tableImgTag"
                                                :class="item.imgTag.color">{{item.imgTag.text}}</div>
                                              </div>
                                              <div v-if="tf.isIconTag">
                                                  <div class="iconTag" v-if="item.iconTag && !!item.iconTag.text" :class="'icon'+item.iconTag.color">{{item.iconTag.text}}</div>
                                              </div>
                                          </template>
                                    </el-col>
                                  </template>
                                  <el-col :span="2">
                                      <span class="trade-mode-tool table-td">
                                          <slot name="tool-icon" :data="item"></slot> 
                                      </span>
                                  </el-col>
                              </el-row>
                          </template>
                      </section>
                  </template>
                  <template v-if="displayMode==='pic'">
                      <el-row :gutter="15" class="trade-pic" id="trade-pic">
                          <template v-for="(item,index) in tradeResultListTemp">
                              <el-col :key="index" :span="4" @click.native="tradePicMouseOver(item,index)">
                                      <div class="trade-pic-item" :class="{light:item.hightLight}">
                                          <div class="trade-pic-box" :style="{height:!ShowPicTitle? '170px' : '150px'}">
                                              <template v-if="!ShowPicTitle">  
                                                  <el-checkbox v-model="item.checked" @change="changeCurrentCheckBox(item)"></el-checkbox>
                                                  <img :style="{maxHeight:!ShowPicTitle? '155px' : '150px'}" v-if="item.url[0]" :src="item.url[0]" :alt="item.title">
                                              </template>
                                              <img v-if="item.url[0] && ShowPicTitle" :src="item.url[0]" :alt="item.title">
                                              <div v-if="!item.url[0]" class="trade-no-img">
                                                  <img :src="noImgUrl" alt="暂无图片">
                                              </div>
                                              <div class="imgTag" v-if="item.imgTag && !!item.imgTag.text" :class="item.imgTag.color">{{item.imgTag.text}}</div>
                                          </div>
                                          <div class="trade-pic-text" v-if="ShowPicTitle">
                                              <span class="pic-checkbox"><el-checkbox v-model="item.checked" @change="changeCurrentCheckBox(item)"></el-checkbox></span>
                                              <div class="trade-pic-title"><slot name="title" :data="item"></slot></div>
                                          </div>
                                          <div class="trade-mode-tool clearfix">
                                              <slot name="tool-icon" :data="item"></slot>
                                          </div>
                                          <div class="leftTag" v-if="item.iconTag && !!item.iconTag.text" :class="'icon'+item.iconTag.color">{{item.iconTag.text}}</div>
                                      </div>
                              </el-col>
                             
                          </template>
                      </el-row>
                  </template>
                  <el-row class="page-sort">
                      <div class="pull-left">
                          <el-select v-model="sort" size="mini" @change="handleSortChange">
                                <template v-if="Object.keys(i18nText).length > 0">
                                      <el-option v-for="(item,index) in sortOption"
                                        :label="$t(item.label)"
                                        :value="item.value"
                                        :key="index"></el-option>
                              </template>
                              <template v-else>
                                <el-option v-for="(item,index) in sortOption"
                                        :label="item.label"
                                        :value="item.value"
                                        :key="index"></el-option>
                              </template>  
                          </el-select>
                      </div>
                      <div class="pull-right">
                          <el-pagination
                                  @size-change="handleSizeChange"
                                  @current-change="handleCurrentChange"
                                  :current-page="currentPage"
                                  :page-sizes="pageSizes"
                                  :page-size="pageSize"
                                  layout="total, sizes, prev, pager, next, jumper"
                                  :total="total">
                          </el-pagination>
                      </div>
                  </el-row>
                </section>
                <section class="right-container" v-else>
                     <template v-if="!!i18nText.noDataQueried">
                        <el-alert :title="$t(i18nText.noDataQueried)" type="info" :closable="false"></el-alert>
                    </template>
                    <template v-else>
                        <el-alert title="没有查询到数据" type="info" :closable="false"></el-alert>
                    </template>
                </section>
            </section>
        </section>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.js';
import floatExtend from './floatExtend'
export default {
    name:'ipSearchOverview',
    props:{
        filterList:{ type:Array,default(){ return [] }},
        tradeResultList:{ type:Array,default(){ return [] }},
        tableField:{type:Array,default(){return []}},
        total:{ type:Number,default:0 },
        currentPage:{ type:Number,default:1 },
        pageSize: {type:Number,default:10 },
        pageSizes:{type:Array,default(){ return [10,20,30]}},
        sortOption:{ type:Array,default(){ return []}},
        sort:{type:String,default(){
          return this.sortOption[0].value
        }},
        loading:{type:Boolean,default:false},
        filterLoading:{type:Boolean,default:false},
        displayView:{type:String,default:'list'},
        ShowPicTitle:{type:Boolean,default:true},
        filterCondition:{type:Array,default(){return []}},
        picModelPlacement:{type:String,default:'bottom'},
        triggerFilter:{type:Boolean,default:false},
        i18nText:{type:Object,default(){
          return {}
        }}
    },
    data(){
        return{
          checkedList:[],
          displayMode:'',
          filterConditionTemp:[],
          currentNode:{},
          noImgUrl:''
        }
    },
    computed:{
      filterListTemp(){
        return this.filterList
      },
      tradeResultListTemp(){
        return this.tradeResultList
      },
      sortTemp:{
        get(){return this.sort},
        set(){}
      }
    },
    watch:{
      filterCondition(newValue,oldValue){
         this.filterConditionTemp = newValue;
      },
      filterListTemp(){
        var self = this;
        if(self.filterConditionTemp){
            self.filterConditionTemp.forEach(item => {
              self.filterListTemp.forEach(temp => {
                    if(item.value === temp.value){
                      temp.list.forEach(list => {
                        let index = item.list.indexOf(list.title);
                        list.checked = index > -1;
                      })
                    }
                })
            })
          }
      },
      triggerFilter(nv,ol){
        if(nv && this.filterConditionTemp.length > 0){
          this.filter();
        }
      }
    },
    mounted(){
      this.displayMode = this.displayView;
      this.filterConditionTemp = this.filterCondition;
      this.noImgUrl = require('../../../../public/image/no_image.jpg')
      var self = this;
      self.$nextTick(()=>{
        if(self.filterConditionTemp){
              self.filterConditionTemp.forEach(item => {
                self.filterListTemp.forEach(temp => {
                      if(item.value === temp.value){
                        temp.list.forEach(list => {
                          let index = item.list.indexOf(list.title);
                          list.checked = index > -1;
                        })
                      }
                  })
              })
            }
      })
      // console.log('this.$slots+++++++++++',this.$slots,this.$scopedSlots)
    },
    methods:{
        tradePicMouseOver(item,index){
          var self = this;
          if(this.currentNode){
            this.currentNode.hightLight = false;
          }
          this.$set(item,'hightLight',true);
          this.currentNode = item;
          const floatWindow = document.querySelector('#floatWindow');
          let dom = document.querySelector("#trade-pic");
          if(floatWindow){
            dom.removeChild(floatWindow);
          }
          var component = new floatExtend({
            propsData:{
              item:item,
              i18nText:self.i18nText
            }
          })
          // 插槽
          if(this.$slots['single-field']){
              component.$slots['single-field'] =  this.$slots['single-field'][0];
          }
          if(this.$slots['title']){
              component.$slots['title'] =  this.$slots['title'][0];
          }
          component.$scopedSlots = new Object();
          if(this.$scopedSlots.title){
              component.$scopedSlots['title'] = this.$scopedSlots.title;
          }
          if(this.$scopedSlots['single-field']){
              component.$scopedSlots['single-field'] = this.$scopedSlots['single-field'];
          }
          // console.log('component.$slots===============>',component.$slots, component.$scopedSlots)
          // end插槽
          component.$mount();
          let position = [Math.floor(index/6)+1]*6
          if(dom.childNodes.length < position){
            position = dom.childNodes.length;
          }
          dom.insertBefore(component.$el,dom.childNodes[position]);
        }, 
        tradePicMouseleave(){
            const floatWindow = document.querySelector('#floatWindow');
            let dom = document.querySelector("#trade-pic");
            if(floatWindow){
              dom.removeChild(floatWindow);
            }
        },
        changeMode(type){
            this.displayMode = type;
        },
        checkThisPage(){
            this.$emit('check-page')
        },
        unCheckThisPage(){
            this.$emit('un-check-page')
        },
        unCheckAll(){
            this.$emit('un-check-all')
        },
        handleChangeFilter(item,param){
            var list = param[2];
            var title = item.title;
            var index = this.filterConditionTemp.findIndex(item => {
                return item.title === title;
            });
            if(index > -1){
                var deleteIndex = -1;
                this.filterConditionTemp.forEach((item,index1) => {
                    if(item.title === title){
                        item.list = list;
                    }
                    if(list.length === 0){
                        deleteIndex = index1;
                    }
                });
                if(deleteIndex > -1){
                    this.filterConditionTemp.splice(deleteIndex,1)
                }
            }else{
                this.filterConditionTemp.push({
                    title: title,
                    value: item.value,
                    list:list
                })
            }
        },
        closefilterConditionTemp(title,item,index){
            item.list.splice(index,1);
            var list = item.list;
            if(list && list.length === 0){
                var tempList = this.filterConditionTemp.filter(value => { return item.title !== value.title });
                this.filterConditionTemp = tempList;
            }
            this.filterListTemp.forEach(function (item) {
                if(item.title === title){
                    item.list.forEach(function (li) {
                        var listIndex = list.findIndex(value =>{ return value === li.title });
                        li.checked = listIndex > -1;
                    });
                }
            });
        },
        clearfilterConditionTemp(){
              this.filterConditionTemp = [];              
              this.filterListTemp.forEach((item,index) => {
                  item.list.forEach((value,index2) => {
                      value.checked = false;
                  });
              });
              this.$emit('clear-filter');
        },
        filter(){
            console.log('this.filterConditionTemp',JSON.stringify(this.filterConditionTemp));
            this.$emit('filter',this.filterConditionTemp);
        },
        changeCurrentCheckBox(item){
          this.$emit('change-checkbox',item)
        },
        handleSizeChange(value){
          this.$emit('size-change',value);
        },
        handleCurrentChange(value){
          this.$emit('current-change',value);
        },
        handleDrilling(item,field){
          this.$emit('drilling',item.field)
        },
        handleSortChange(sort){
          this.$emit('sort-change',sort)
        }
    }
}
</script>

<style lang="scss">
.trade-pic-tooltip.el-tooltip__popper.is-light{
    border: solid 1px #e4e7ed;
    border-radius: 0;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,0.2);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.2);
}
.trade-pic-tooltip.el-tooltip__popper.is-light[x-placement^="top"] .popper__arrow{
  border-top-color: #e4e7ed;
}
.trade-pic-tooltip.el-tooltip__popper.is-light[x-placement^="bottom"] .popper__arrow{
  border-bottom-color: #e4e7ed;
}
</style>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 6px;
  background-color: #e5e5e5;
}

::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
}
#ip-overview{
  .yellow {
      background: #f89406;
  }
  .grey {
      background: #A3ABAE;
  }
  .red {
      background: #DF5320;
  }
  .blue {
      background: #5C9BD1;
  }
  .skyblue {
      background: #32c5d2;
  }
  .green {
      background: #26C281;
  }
  .iconyellow {
      color:#f89406 ;
      border:1px solid #f89406;
  }
  .icongrey {
      color:#A3ABAE ;
      border:1px solid #A3ABAE;
  }
  .iconred {
      color:#DF5320 ;
      border:1px solid #DF5320;
  }
  .iconblue {
      color:#5C9BD1 ;
      border:1px solid #5C9BD1;
  }
  .iconskyblue {
      color:#32c5d2 ;
      border:1px solid #32c5d2;
  }
  .icongreen {
      color:#26C281 ;
      border:1px solid #26C281;
  }
  padding: 15px;
  position: relative;
  min-height:700px;
  background: #F0F0F0;
  font-size: $sm-font-size;
  .left-side{
    width: 275px;
    min-height: 700px;
    position: absolute;
    background: #fff;
    h2{
      font-size: $md-font-size;
      padding:10px 15px;
      font-weight: bold;
    }
  }
  .right-side{
    width: 100%;
    padding-left: 290px;
    box-sizing: border-box;
    .tool-container{
      margin-bottom: 15px;
      padding: 10px 15px;
      background: #fff;
      .filter-condition{
        h2{
          margin-bottom: 10px;
          display: inline-block;
          font-size: $sm-font-size;
          font-weight: normal;
        }
      }
      .mb8{
        span{
          margin-right: 8px;
          font-size: $sm-font-size;
        }
        margin-bottom: 8px;
      }
      .el-tag{
        margin-right: 8px;
      }
      .el-input-group__prepend{
        background: #ffffff;
        .el-select{
          .el-input{
            width: 130px;
          }
        }
      }
      .el-input-group__append{
        .el-button--primary{
          background: $theme-color;
          color: #ffffff;
          padding: 9px 20px;
        }
      }
      .tool-item{
        margin-right: 20px;
        .el-button--text{
          color:#333;
          .iconfont{
            margin-right: 6px;
          }
        }
      }
    }
    .right-container{
      padding: 15px;
      box-sizing: border-box;
      min-height: 500px;
      background: #ffffff;
      .tool-container{
        padding: 0;
      }

      .trade-list-item{
        padding-left: 25px;
        position: relative;
        box-sizing: border-box;
        border-bottom: $primary-border;
        margin-bottom: 15px;
        .trade-checkbox{
          position: absolute;
          left: 0;
          top: 0;
        }
      }
      .trade-pic{
        margin-bottom: 10px;
      }
      .light{
        border: 1px solid $theme-color!important;
      }
      .trade-pic-item{
        margin: 8px 1%;
        height: 205px;
        border: $primary-border;
        padding: 10px;
        overflow: hidden;
        position: relative;
        .trade-pic-box{
          width: 100%;
          height: 150px;
          padding: 4px 4px 0 4px;
          border: none;
          overflow-y: hidden;
          position: relative;
          margin-bottom: 8px;
          box-sizing: border-box;
          img{
            display: block;
            max-width: 100%;
            margin-left: auto;
            margin-right: auto;
            max-height: 130px;
          }
          .imgTag{
            position:absolute;
            bottom:0;
            left: 0;
            text-align:center;
            width:56px;
            color:#fff;
            font-size:$sm-font-size;
            height: 24px;
            line-height:24px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
        }
        .leftTag{
            position:absolute;
            left:0px;
            top: 0px;
            text-align:center;
            width:20px;
            font-size:$xs-font-size;
            height: 20px;
            line-height:20px;
            background: #ffffff;
            font-weight: bold;
          }
        .trade-pic-text{
          position: relative;
          .pic-checkbox{
            position: absolute;
            top: 0;
            left: 0;
          }
          .trade-pic-title{
            color: $theme-color;
            cursor: pointer;
            text-decoration: none;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            padding-left: 20px;
            line-height: 18px;
            font-size: 14px;
          }
        }
        .trade-mode-tool{
          position:absolute;
          right: 6px;
          bottom: 4px;
          margin-top: 4px;
          .el-button--text{
            padding: 2px 4px;
          }
          .el-button--text:hover{
            color: #ffffff;
            background: $theme-color;
          }
        }
      }
      .trade-pic-item:hover{
          -webkit-box-shadow: 0 5px 12px 0 rgba(0,0,0,.1);
          box-shadow: 0 5px 12px 0 rgba(0,0,0,.1);
      }
      .trade-table{
        margin-bottom: 20px;
        .table-td{
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 74px;
        }
        .tableImgTag{
            width: 56px;
            margin: 0 auto;
            height: 24px;
            line-height: 24px;
            color: #ffffff;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
        }
        .iconTag{
          width: 30px;
          height: 30px;
          line-height: 30px;
          margin: auto;
          font-weight: bold;
          background: #ffffff;
        }
        .table-title{
          padding: 15px;
          text-align: center;
          background: #f0f3f7;
        }
        .trade-table-item{
          min-height: 53px;
          line-height: 53px;
          box-sizing: border-box;
          padding: 8px 0;
          border-bottom: $primary-border;
          text-align: center;
          .long-word{
            white-space: nowrap;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
          }
          .table-img{
            width: 100px;
            height: 50px;
            text-align: center;
            margin: 0 auto;
            overflow: hidden;
            img{
              max-width: 100%;
              max-height: 100%;
              vertical-align: middle;
            }
          }
          .trade-mode-tool{
            .el-button--text{
              padding: 2px 4px;
            }
            .el-button--text:hover{
              color: #ffffff;
              background: $theme-color;
            }
          }
        }
      }
      .page-sort{
        margin-bottom: 20px;
      }
    }
  }
}
</style>
